import * as $ from "jquery";

const ELEMENT_CLASS = '.fade-up-animation';
const IN_VIEW_ANIMATION_CLASS_NAME = 'fade-up-animation--in-view';

export default class FadeUpAnimation {
  $window?: JQuery<Window & typeof globalThis>;
  $animationElements?: JQuery<HTMLElement>;
  constructor() {
    $(document).ready(this.init.bind(this));
  }

  init() {
    this.$window = $(window);
    this.$animationElements = $(ELEMENT_CLASS);

    this.$window.on('scroll resize', this.handleScrollResize.bind(this));
    this.$window.trigger('scroll');
  }

  handleScrollResize() {
    const windowHeight = this.$window.height() * 2; // start animation 2x of screen-height
    const windowTopPosition = this.$window.scrollTop();
    const windowBottomPosition = (windowTopPosition + windowHeight);

    $.each(this.$animationElements, function() {
      const $element = $(this);
      const elementHeight = $element.outerHeight();
      const elementTopPosition = $element.offset().top;
      const elementBottomPosition = (elementTopPosition + elementHeight);

      if (
        elementBottomPosition >= windowTopPosition &&
        elementTopPosition <= windowBottomPosition
      ) {
        $element.addClass(IN_VIEW_ANIMATION_CLASS_NAME);
      }
    });
  }
}
